import { Anchor, InfoModal } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  WithTrackEventProps,
} from "@newsela/snitch";

import { IPageViewModelStandard } from "@/types/models/ContentPageViewModel.interface";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  hideFooterCss,
  modalContentWrapperCss,
  rootCss,
  standardDescriptionCss,
  standardWrapperCss,
} from "./UnlevelledContentStandardsModal.style";

interface UnlevelledContentStandardsModalProps {
  standards: IPageViewModelStandard[];
  standardsLabel: string;
  setActive: (active: boolean) => void;
  modalProps: any;
}

type AnchorProps = React.ComponentProps<typeof Anchor> | WithTrackEventProps;
const AnchorWithTrackEvent = withTrackEvent(
  Anchor,
) as React.ForwardRefExoticComponent<
  AnchorProps & React.RefAttributes<HTMLAnchorElement>
>;

const UnlevelledContentStandardsModal = ({
  standards,
  standardsLabel,
  setActive,
  modalProps,
}: UnlevelledContentStandardsModalProps) => {
  return (
    <InfoModal
      labelId="Standards"
      onBackgroundClick={() => setActive(false)}
      title={standardsLabel}
      __cssFor={{
        root: rootCss,
        modalContentWrapper: modalContentWrapperCss,
        footer: hideFooterCss,
      }}
      {...modalProps}
    >
      {standards.map((standard) => (
        <div css={standardWrapperCss} key={standard.id}>
          <AnchorWithTrackEvent
            actionName={actionNames.search}
            actionPrefix={actionPrefixes.initiate}
            dataProps={{
              "data-qa-selector":
                "generation_genius_standard_modal_search_link",
            }}
            href={`${MONOLITH_ORIGIN}/search/?standards=${standard.id}`}
            isInline
            objectType={objectTypes.content}
            openInNewTab
            streamProperties={{
              description: `search for standard related content to ${standard.name}`,
            }}
          >
            {standard.name}
          </AnchorWithTrackEvent>
          <p css={standardDescriptionCss}>{standard.description}</p>
        </div>
      ))}
    </InfoModal>
  );
};

export default UnlevelledContentStandardsModal;
